// user
export const LOGIN = "LOGIN"; // login
export const LOGOUT = "LOGOUT"; // logout
export const SET_ME = "SET_ME"; // set me

// customers
export const SET_CUSTOMERS = "SET_CUSTOMERS";
export const SORT_CUSTOMERS = "SORT_CUSTOMERS";
export const UPSERT_CUSTOMER = "UPSERT_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";

// suppliers
export const SET_SUPPLIERS = "SET_SUPPLIERS";
export const SORT_SUPPLIERS = "SORT_SUPPLIERS";
export const UPSERT_SUPPLIER = "UPSERT_SUPPLIER";
export const DELETE_SUPPLIER = "DELETE_SUPPLIER";

// greenhouses
export const SET_GREENHOUSES = "SET_GREENHOUSES";
export const SORT_GREENHOUSES = "SORT_GREENHOUSES";
export const UPSERT_GREENHOUSE = "UPSERT_GREENHOUSE";
export const DELETE_GREENHOUSE = "DELETE_GREENHOUSE";
export const UPDATE_GREENHOUSE_DEPARTMENT_LAYOUTS =
    "UPDATE_GREENHOUSE_DEPARTMENT_LAYOUTS";

// greenhouse departments
export const SET_GREENHOUSE_DEPARTMENTS = "SET_GREENHOUSE_DEPARTMENTS";
export const SORT_GREENHOUSE_DEPARTMENTS = "SORT_GREENHOUSE_DEPARTMENTS";
export const UPSERT_GREENHOUSE_DEPARTMENT = "UPSERT_GREENHOUSE_DEPARTMENT";
export const DELETE_GREENHOUSE_DEPARTMENT = "DELETE_GREENHOUSE_DEPARTMENT";

// greenhouse department sections
export const SET_GREENHOUSE_DEPARTMENT_SECTIONS =
    "SET_GREENHOUSE_DEPARTMENT_SECTIONS";
export const SORT_GREENHOUSE_DEPARTMENT_SECTIONS =
    "SORT_GREENHOUSE_DEPARTMENT_SECTIONS";
export const UPSERT_GREENHOUSE_DEPARTMENT_SECTION =
    "UPSERT_GREENHOUSE_DEPARTMENT_SECTION";
export const DELETE_GREENHOUSE_DEPARTMENT_SECTION =
    "DELETE_GREENHOUSE_DEPARTMENT_SECTION";

// plants
export const SET_CURRENT_PLANT = "SET_CURRENT_PLANT";
export const SET_PLANTS = "SET_PLANTS";
export const SORT_PLANTS = "SORT_PLANTS";
export const UPSERT_PLANT = "UPSERT_PLANT";
export const DELETE_PLANT = "DELETE_PLANT";

// plant species
export const SET_PLANT_SPECIES = "SET_PLANT_SPECIES";
export const SORT_PLANT_SPECIES = "SORT_PLANT_SPECIES";
export const UPSERT_PLANT_SPECIES = "UPSERT_PLANT_SPECIES";
export const DELETE_PLANT_SPECIES = "DELETE_PLANT_SPECIES";

// plant colors
export const SET_COLORS = "SET_COLORS";
export const SORT_COLORS = "SORT_COLORS";
export const UPSERT_COLOR = "UPSERT_COLOR";
export const DELETE_COLOR = "DELETE_COLOR";

// plant tags
export const SET_TAGS = "SET_TAGS";
export const SORT_TAGS = "SORT_TAGS";
export const UPSERT_TAG = "UPSERT_TAG";
export const DELETE_TAG = "DELETE_TAG";

// pot size
export const SET_POT_SIZES = "SET_POT_SIZES";
export const SORT_POT_SIZES = "SORT_POT_SIZES";
export const UPSERT_POT_SIZE = "UPSERT_POT_SIZE";
export const DELETE_POT_SIZE = "DELETE_POT_SIZE";

// plant growth templates
export const SET_PLANT_GROWTH_TEMPLATES = "SET_PLANT_GROWTH_TEMPLATES";
export const SORT_PLANT_GROWTH_TEMPLATES = "SORT_PLANT_GROWTH_TEMPLATES";
export const UPSERT_PLANT_GROWTH_TEMPLATE = "UPSERT_PLANT_GROWTH_TEMPLATE";
export const DELETE_PLANT_GROWTH_TEMPLATE = "DELETE_PLANT_GROWTH_TEMPLATE";

// plant environments
export const SET_ENVIRONMENTS = "SET_ENVIRONMENTS";
export const SORT_ENVIRONMENTS = "SORT_ENVIRONMENTS";
export const UPSERT_ENVIRONMENT = "UPSERT_ENVIRONMENT";
export const DELETE_ENVIRONMENT = "DELETE_ENVIRONMENT";

// products
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SORT_PRODUCTS = "SORT_PRODUCTS";
export const UPSERT_PRODUCT = "UPSERT_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";

// product categories
export const SET_PRODUCT_CATEGORIES = "SET_PRODUCT_CATEGORIES";
export const SORT_PRODUCT_CATEGORIES = "SORT_PRODUCT_CATEGORIES";
export const UPSERT_PRODUCT_CATEGORY = "UPSERT_PRODUCT_CATEGORY";
export const DELETE_PRODUCT_CATEGORY = "DELETE_PRODUCT_CATEGORY";

// product items
export const SET_PRODUCT_ITEMS = "SET_PRODUCT_ITEMS";
export const SORT_PRODUCT_ITEMS = "SORT_PRODUCT_ITEMS";
export const UPSERT_PRODUCT_ITEM = "UPSERT_PRODUCT_ITEM";
export const DELETE_PRODUCT_ITEM = "DELETE_PRODUCT_ITEM";

// growth tasks
export const SET_GROWTH_TASKS = "SET_GROWTH_TASKS";
export const SORT_GROWTH_TASKS = "SORT_GROWTH_TASKS";
export const UPSERT_GROWTH_TASK = "UPSERT_GROWTH_TASK";
export const UPSERT_GROWTH_TASK_PHASES = "UPSERT_GROWTH_TASK_PHASES";
export const UPDATE_GROWTH_TASK_TAG = "UPDATE_GROWTH_TASK_TAG";
export const CONFIRM_GROWTH_TASK_PHASE = "CONFIRM_GROWTH_TASK_PHASE";
export const DELETE_GROWTH_TASK = "DELETE_GROWTH_TASK";
export const LOCK_GROWTH_TASK = "LOCK_GROWTH_TASK";
export const UNLOCK_GROWTH_TASK = "UNLOCK_GROWTH_TASK";
export const SPLIT_GROWTH_TASK = "SPLIT_GROWTH_TASK";
export const UPDATE_GROWTH_TASK_INVENTORY = "UPDATE_GROWTH_TASK_INVENTORY";
export const UPDATE_GROWTH_TASK_SUPPLIER = "UPDATE_GROWTH_TASK_SUPPLIER";
export const SET_GROWTH_TASK_INVENTORY_BY_PLANT =
    "SET_GROWTH_TASK_INVENTORY_BY_PLANT";
export const SEARCH_GROWTH_TASK_BY_PLANT = "SEARCH_GROWTH_TASK_BY_PLANT";

// inventory change reason tag
export const SET_INVENTORY_CHANGE_REASON_TAGS = "SET_INVENTORY_CHANGE_REASON_TAGS";
export const SORT_INVENTORY_CHANGE_REASON_TAGS = "SORT_INVENTORY_CHANGE_REASON_TAGS";
export const UPSERT_INVENTORY_CHANGE_REASON_TAG = "UPSERT_INVENTORY_CHANGE_REASON_TAG";
export const DELETE_INVENTORY_CHANGE_REASON_TAG = "DELETE_INVENTORY_CHANGE_REASON_TAG";

// sales orders
export const SET_ALL_SALES_ORDERS = "SET_ALL_SALES_ORDERS";
export const SET_ACTIVE_SALES_ORDERS = "SET_ACTIVE_SALES_ORDERS";
export const SET_SALES_ORDERS_PICKLIST = "SET_SALES_ORDERS_PICKLIST";
export const SORT_SALES_ORDERS = "SORT_SALES_ORDERS";
export const UPSERT_SALES_ORDER = "UPSERT_SALES_ORDER";
export const DELETE_SALES_ORDER = "DELETE_SALES_ORDER";

// planner
export const SET_PLANNED_TASKS = "SET_PLANNED_TASKS";
export const SORT_PLANNED_TASKS = "SORT_PLANNED_TASKS";
export const UPSERT_PLANNED_TASK = "UPSERT_PLANNED_TASK";
export const UPSERT_PLANNED_TASK_STATUS = "UPSERT_PLANNED_TASK_STATUS";
export const DELETE_PLANNED_TASK = "DELETE_PLANNED_TASK";
